// components/AddressAutocomplete.jsx — the words around Google address
// suggestions. The attribution itself ("Google Maps") is never translated:
// Google's terms ask for the brand exactly as written.
export const PLACES_L = {
  en: {
    searching: "Searching…",
    carTown: "Cars to rent with Toukky",
    list: "Address suggestions",
    results: (n) => (n === 1 ? "1 address suggested. Use the up and down arrows to choose." : `${n} addresses suggested. Use the up and down arrows to choose.`),
    none: "No address found. Your text is kept.",
  },
  fr: {
    searching: "Recherche…",
    carTown: "Voitures à louer avec Toukky",
    list: "Adresses proposées",
    results: (n) => (n === 1 ? "1 adresse proposée. Utilisez les flèches haut et bas pour choisir." : `${n} adresses proposées. Utilisez les flèches haut et bas pour choisir.`),
    none: "Aucune adresse trouvée. Votre texte est conservé.",
  },
  es: {
    searching: "Buscando…",
    carTown: "Coches de alquiler con Toukky",
    list: "Direcciones sugeridas",
    results: (n) => (n === 1 ? "1 dirección sugerida. Use las flechas arriba y abajo para elegir." : `${n} direcciones sugeridas. Use las flechas arriba y abajo para elegir.`),
    none: "No se encontró ninguna dirección. Se conserva su texto.",
  },
  pt: {
    searching: "Buscando…",
    carTown: "Carros para alugar com a Toukky",
    list: "Endereços sugeridos",
    results: (n) => (n === 1 ? "1 endereço sugerido. Use as setas para cima e para baixo para escolher." : `${n} endereços sugeridos. Use as setas para cima e para baixo para escolher.`),
    none: "Nenhum endereço encontrado. O seu texto foi mantido.",
  },
  ar: {
    searching: "جار البحث…",
    carTown: "سيارات للإيجار مع Toukky",
    list: "العناوين المقترحة",
    results: (n) => `${n} من العناوين المقترحة. استخدم سهمي الأعلى والأسفل للاختيار.`,
    none: "لم يتم العثور على أي عنوان. تم الاحتفاظ بالنص الذي كتبته.",
  },
  zh: {
    searching: "搜索中…",
    carTown: "可通过 Toukky 租车",
    list: "地址建议",
    results: (n) => `找到 ${n} 个地址建议。使用上下方向键选择。`,
    none: "未找到地址，已保留您输入的内容。",
  },
};
